export default __webpack_public_path__ + "static/media/warning--double-side-roads-right--g3.f828d2c5.png";